// The one bounded diagnostic ring behind TTV's telemetry trails — the stability trail and the product-analytics trail both keep a short in-memory history of what they emitted, and both need exactly this shape. It lived twice, byte for byte, before this factory. The records array is private to the returned accessors: a writer cannot bypass the cap, and a reader receives detached copies, so inspecting a trail can never mutate it or the records already retained.
export const createBoundedEventRing = <TRecord extends object>(
  maxEvents: number
) => {
  const records: TRecord[] = [];

  // A spread is not enough to detach these records: an analytics event carries an array (the roster's voice ids), and a shallow copy leaves that array shared between the caller's object, the retained record, every read copy and the payload handed to posthog.capture — so one mutation anywhere rewrites the history. Both trails carry nothing but plain data (enums, counts, flags, string arrays), which is exactly what structuredClone handles.
  const detach = (record: TRecord): TRecord => structuredClone(record);

  return {
    append: (record: TRecord): void => {
      records.push(detach(record));
      if (records.length > maxEvents) {
        records.splice(0, records.length - maxEvents);
      }
    },
    read: (): readonly TRecord[] => records.map(detach),
    clear: (): void => {
      records.length = 0;
    },
  };
};
